/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import alert from 'react-s-alert';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { InputTemplate } from 'modules/common/components/inputComponents';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import * as action from '../actions';
import * as c from '../constant';

function TransferModal({
  transferTaxCredit,
  getTaxCreditList,
  validateTransferReceiver,
  history,
  updating,
  id,
}) {

  const [formData, setFormData] = useState({
    pin: '',
    amount: '',
  });
  
  const [showAmount, setShowAmount] = useState(false);

  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    pin: 'required|rptax_pin_23',
    receiver_tax_credit_id: 'required',
    amount: 'required|number',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      receiver_tax_credit_id: +_.get(formData, 'receiver_tax_credit_id'),
      amount: _.get(formData, 'amount'),
    };

    transferTaxCredit(id, args, () => {
      setModal({ isOpen: false });
      getTaxCreditList();
      history.push('/rpt/building/settings/tax-credit');
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    if (showAmount) {
      setShowAmount(false);
    }
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <label className="px-3">
            Search for a PIN first before you can proceed.
          </label>
          <div className="col-12">
            <InputTemplate
              title="Search PIN"
              htmlFor="pin"
              labelClassName="form-label"
              containerClassName=""
              formValidatorMsg={validateForm.renderMessage('pin')}
              placeholder="PIN"
              className="full-input"
              type="text"
              name="pin"
              id="pin"
              actionButtonContainerClass="border"
              withActionButton={() => {
                return (
                  <button
                    type="button"
                    className="btn px-2 font-weight-bold"
                    onClick={() =>
                      validateTransferReceiver(
                        id,
                        { receiver_pin: _.get(formData, 'pin') },
                        ({ data }) => {
                          alert.success(
                            'Your application was successfully validated!'
                          );
                          setFormData({
                            ...formData,
                            receiver_tax_credit_id: data.id,
                          });
                          setShowAmount(true);
                        }
                      )
                    }
                  >
                    Search
                  </button>
                );
              }}
              withCustomInputComponent={() => (
                <InputMask
                  className="form-control"
                  mask="999-99-999-999-999-*****"
                  alwaysShowMask
                  type="text"
                  name="pin"
                  onChange={onChange}
                  value={_.get(formData, 'pin')}
                />
              )}
            />
          </div>
          {showAmount && (
            <div className="col-12">
              <InputTemplate
                title="Amount"
                labelClassName="form-label"
                formValidatorMsg={validateForm.renderMessage('amount')}
                withCustomInputComponent={() => (
                  <NumberFormat
                    name="amount"
                    id="amount"
                    placeholder="PHP 0.00"
                    className="form-control"
                    onValueChange={(values) => {
                      const { floatValue } = values;
                      setFormData(() => ({
                        ...formData,
                        amount: floatValue >= 0 ? floatValue : '',
                      }));
                    }}
                    isNumericString
                    thousandSeparator
                    allowNegative
                    allowLeadingZeros
                    displayType="input"
                    prefix="PHP "
                    value={_.get(formData, 'amount')?.toString()}
                  />
                )}
              />
            </div>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

TransferModal.propTypes = {
  transferTaxCredit: PropTypes.instanceOf(Function).isRequired,
  getTaxCreditList: PropTypes.instanceOf(Function).isRequired,
  validateTransferReceiver: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TAX_CREDIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(TransferModal);
